import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-16 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-83" data-mp="ej4o9zmlcfgi">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative flex flex-col items-center text-center" data-id="element-84" data-mp="9lv0spiridvb">
        {/* Feature Photo */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6
      }} className="relative w-full max-w-md mb-16" data-id="element-85" data-mp="4jm5hmif2zq1">
          <div className="relative z-10 border-4 border-foodMaroon shadow-[12px_12px_0px_0px_#E25822] bg-foodMaroon aspect-square overflow-hidden" data-id="element-86" data-mp="sd4d16jx3gql">
            <video src="https://cdn.magicpatterns.com/uploads/vcVSEnXeMgnsW1gcw59Si2/9C109C8D-7AAF-4D5D-9F55-404EBA828499.MOV" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-87" data-mp="3d2l95b1th306" />
          </div>

          {/* Decorative Elements */}
          <motion.div animate={{
          scale: [1, 1.08, 1]
        }} transition={{
          duration: 1.6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute top-1/2 -translate-y-1/2 -right-8 z-20 w-32 h-32 bg-foodGold rounded-full flex items-center justify-center border-4 border-foodMaroon shadow-[4px_4px_0px_0px_#3D1610]" data-id="element-88" data-mp="3o59chkk9b8f2">
            <div className="text-center" data-id="element-89" data-mp="2qkwjgydc3vu4">
              <span className="block font-display font-bold text-foodMaroon text-2xl leading-tight" data-id="element-90" data-mp="2qhqv5lcj4xzg">
                AUGUST
              </span>
              <span className="block font-display font-bold text-foodMaroon text-xl leading-tight" data-id="element-91" data-mp="2hix1a2ql2lpl">
                POP UP
              </span>
            </div>
          </motion.div>

          <div className="absolute -bottom-6 -left-6 z-0 w-full h-full bg-foodTomato border-4 border-foodMaroon" data-id="element-92" data-mp="s1rrwn4sk4tr" />
        </motion.div>

        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col items-center" data-id="element-93" data-mp="n98d5mudb3nd">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-foodGold text-foodMaroon font-bold mb-6 border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#3D1610] rotate-[-2deg]" data-id="element-94" data-mp="161t2iuauyqmf">
            <Sparkles size={20} data-id="element-95" data-mp="114ki0n28mai0" />
            <span data-id="element-96" data-mp="x1nvwmdhnw9b">Community Food Hub</span>
          </div>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold leading-[1.1] mb-6 uppercase max-w-4xl" data-id="element-97" data-mp="x37b09nes19i">
            Where Our Community <span className="text-foodOrange" data-id="element-98" data-mp="3hqu2kaecg816">Gathers</span>
            , Cooks & Celebrates.
          </h1>
          <p className="text-lg sm:text-xl text-foodMaroon/80 mb-8 font-medium max-w-2xl" data-id="element-99" data-mp="1xa41h7xz88gg">
            Join us for vibrant monthly pop-ups, hands-on culinary workshops,
            and community events that bring our neighborhood together through
            food.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-100" data-mp="2b0fwbely4lba">
            <a href="#popups" className="inline-flex justify-center items-center gap-2 bg-foodOrange text-white px-8 py-4 font-bold text-lg border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#3D1610] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0px_0px_#3D1610] transition-all" data-id="element-101" data-mp="2b2sjq7ah3nvq">
              See This Month's Pop-Up
              <ArrowRight size={20} data-id="element-102" data-mp="2tysgrwib5hm6" />
            </a>
            <a href="#workshops" className="inline-flex justify-center items-center gap-2 bg-transparent text-foodMaroon px-8 py-4 font-bold text-lg border-4 border-foodMaroon hover:bg-foodMaroon hover:text-foodCream transition-colors" data-id="element-103" data-mp="umzkk23cggai">
              Join a Workshop
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}